import { left, right } from 'fp-ts/Either';

import { httpClientFunction } from 'domain/types';
import Permissions, { PERMISSIONS } from 'domain/entity/permissions';
import ReadPermissionsClient from 'use-case/permissions/read/readPermissionsClient';

const readPermissionsApiClient = (httpClient: httpClientFunction, baseUrl: string): ReadPermissionsClient => () =>
    httpClient(`${baseUrl}/dashboards/permissions`, {})
        .then((response) =>
            response.ok
                ? response
                      .json()
                      .then(asPermissions)
                      .then(right)
                      .catch(() => left({ error: new Error(), status: 500 }))
                : left({ error: new Error(), status: response.status })
        )
        .catch(() => left({ error: new Error(), status: 503 }));

const asPermissions = (permissionsJson: PermissionsJson) => {
    const mappedPermissions = new Map(permissionsJson.permitted_actions.map((permission) => [permission, true]));
    return new Permissions(mappedPermissions.has(PERMISSIONS.CREATE));
};

export type PermissionsJson = {
    ['permitted_actions']: string[];
};

export default readPermissionsApiClient;
